import { useEffect, useState } from 'react';
import { apiClient } from '@/core/api/client';

interface MaintenanceData {
  enabled: boolean;
  message: string;
}

export function MaintenancePage({ message }: { message: string }) {
  const [checking, setChecking] = useState(false);

  return (
    <div className="maintenance-page">
      {/* Top Hazard Bar */}
      <div className="hazard-strip-top" />

      {/* Main Content */}
      <main className="maintenance-content">
        {/* Icon */}
        <div className="maintenance-icon-wrapper">
          <div className="maintenance-icon-glow" />
          <svg 
            className="maintenance-icon" 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={1.5} 
              d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" 
            />
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={1.5} 
              d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" 
            />
          </svg>
        </div>

        {/* Title */}
        <div className="maintenance-title-section">
          <h1 className="maintenance-title">
            Under <span className="maintenance-title-highlight">Maintenance</span>
          </h1>
          <p className="maintenance-subtitle">
            {message || 'We are performing scheduled maintenance to improve your experience. Everything will be back online shortly.'}
          </p>
        </div>

        {/* Status Card */}
        <div className="maintenance-status-card">
          <div className="maintenance-almost-done">
            Almost Done
          </div>

          <div className="maintenance-progress-wrapper">
            <div className="maintenance-progress-bar">
              <div className="maintenance-progress-fill" />
            </div>
            <div className="maintenance-progress-info">
              <span>Deployment 90%</span>
              <span className="maintenance-live-indicator">
                <span className="maintenance-live-dot" />
                Live Updates
              </span>
            </div>
          </div>
        </div>

        {/* Actions */}
        <div className="maintenance-actions">
          <a 
            href="mailto:www.shinehappy@gmail.com" 
            className="maintenance-btn maintenance-btn-secondary"
          >
            Contact Support
          </a>
        </div>
      </main>

      {/* Bottom Hazard Bar */}
      <div className="hazard-strip-bottom" />
    </div>
  );
}
